<!-- eslint-disable vue/valid-template-root -->
<template>
  <!-- We are only rendering scripts here -->
</template>

<script lang="ts">
export default {
  name: 'ScriptLoader',
  props: {
    scriptContent: {
      type: String,
      required: true,
    },
    scriptId: {
      type: String,
      required: true,
    },
  },
  data() {
    return {
      scriptElement: null,
    }
  },
  watch: {
    scriptContent: {
      immediate: true,
      handler(newContent) {
        if (newContent) {
          this.loadScript()
        }
      },
    },
  },
  methods: {
    loadScript() {
      this.removeScript()

      try {
        const script = document.createElement('script')
        script.id = this.scriptId
        script.innerHTML = this.scriptContent

        this.scriptElement = script

        document.head.appendChild(script)
        this.error = null
      } catch (err) {
        console.error(`Script loading error`, err) // eslint-disable-line no-console
      }
    },
    removeScript() {
      if (this.scriptElement) {
        document.head.removeChild(this.scriptElement)
        this.scriptElement = null
      }
    },
  },
  beforeDestroy() {
    this.removeScript()
  },
}
</script>
